// extracted by mini-css-extract-plugin
export default {"root":"TopbarSpacer_root__YOvw9"};